export default {
      id: "xtype_xwaste-usage",
      viewBox: "0 0 34 16",
      url: __webpack_public_path__ + "img/icons.svg#xtype_xwaste",
      toString: function () {
        return this.url;
      }
    }